import { getCashOutOverview } from "@payping/redux/actions";
import { FC } from "react";
import { useAsync } from "react-use";
import { useAppDispatch } from "@/utils/redux";
import CreateId from "./create";

const Create: FC = () => {
  const dispatch = useAppDispatch();

  useAsync(() => dispatch(getCashOutOverview()));

  return <CreateId />;
};

export default Create;
